import { useRef, useCallback } from "react";

/**
 * @callback DelayedCall
 * @param {() => void} callback
 * @param {number} delay
 */

/**
 * @callback CancelDelayedCall
 * @returns {void}
 */

/**
 * @returns {{ delayedCall: DelayedCall, cancelDelayedCall: CancelDelayedCall }}
 */
export function useDelayedSetState() {
  const timeoutRef = useRef(/** @type {NodeJS.Timeout | null} */ (null));

  const delayedCall = useCallback(
    /** @type {DelayedCall} */
    (callback, delay) => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      timeoutRef.current = setTimeout(callback, delay);
    },
    [],
  );

  const cancelDelayedCall = useCallback(
    /** @type {CancelDelayedCall} */
    () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    },
    [],
  );

  return { delayedCall, cancelDelayedCall };
}
